var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ComponenteDatoGeneral',{attrs:{"titulo":" Incidentes Abiertos vs Cerrados"}})
}
var staticRenderFns = []

export { render, staticRenderFns }